var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          loading: _vm.loading,
          search: _vm.search,
          items: _vm.ftpSubAccounts
        },
        scopedSlots: _vm._u([
          {
            key: "item.dir",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                _c("path-info", {
                  attrs: {
                    path: item.dir
                  }
                })
              ]
            }
          },
          {
            key: "item._diskused",
            fn: function fn(_ref2) {
              var item = _ref2.item
              return [
                item.humandiskquota !== "None"
                  ? _c("v-progress-linear", {
                      attrs: {
                        color: "primary",
                        height: "26",
                        value: _vm.quotaPercentage(item.diskusedpercent_float)
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function fn(_ref3) {
                              var value = _ref3.value
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(item.humandiskused) +
                                    " / " +
                                    _vm._s(item.humandiskquota) +
                                    " "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  : _c("v-progress-linear", {
                      attrs: {
                        color: "primary",
                        height: "26",
                        value: "0"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function fn(_ref4) {
                              var value = _ref4.value
                              return [
                                _vm._v(
                                  " " + _vm._s(item.humandiskused) + " / ∞ "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
              ]
            }
          },
          {
            key: "item.actions",
            fn: function fn(_ref5) {
              var item = _ref5.item
              return [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      top: "",
                      "offset-y": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function fn(_ref6) {
                            var on = _ref6.on,
                              attrs = _ref6.attrs
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(_vm._b({}, "gg-btn", attrs, false), on),
                                [
                                  _vm._v(" Manage "),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-1"
                                    },
                                    [_vm._v("mdi-chevron-down")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openConfigureModal(item)
                              }
                            }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("FTP Information")])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openPathModal(item)
                              }
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("Change Home Path")
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openQuotaModal(item)
                              }
                            }
                          },
                          [_c("v-list-item-title", [_vm._v("Change Quota")])],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openPasswordModal(item)
                              }
                            }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("Change Password")])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openDeleteModal(item)
                              }
                            }
                          },
                          [_c("v-list-item-title", [_vm._v("Delete")])],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm.selectedAccount
        ? _c("delete-modal", {
            attrs: {
              opened: _vm.deleteModal,
              account: _vm.selectedAccount
            },
            on: {
              "account-deleted": _vm.reload,
              close: _vm.closeDeleteModal
            }
          })
        : _vm._e(),
      _vm.selectedAccount
        ? _c("change-password-modal", {
            attrs: {
              opened: _vm.passwordModal,
              account: _vm.selectedAccount
            },
            on: {
              close: _vm.closePasswordModal
            }
          })
        : _vm._e(),
      _vm.selectedAccount
        ? _c("change-quota-modal", {
            attrs: {
              opened: _vm.quotaModal,
              account: _vm.selectedAccount
            },
            on: {
              "quota-updated": _vm.reload,
              close: _vm.closeQuotaModal
            }
          })
        : _vm._e(),
      _vm.selectedAccount
        ? _c("configure-modal", {
            attrs: {
              opened: _vm.configureModal,
              account: _vm.selectedAccount
            },
            on: {
              close: _vm.closeConfigureModal
            }
          })
        : _vm._e(),
      _vm.selectedAccount
        ? _c("change-home-path-modal", {
            attrs: {
              account: _vm.selectedAccount
            },
            on: {
              updated: _vm.reload
            },
            model: {
              value: _vm.nameModal,
              callback: function callback($$v) {
                _vm.nameModal = $$v
              },
              expression: "nameModal"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }